<iot-platform-ui-simple-card
  (dispatchEvent)="onDispatchEvent($event)"
  [actions]="actions()"
  [cssClasses]="cssClasses()"
  [element]="element()"
  [icon]="icon()"
  [withMenu]="withMenu()"
  class="card"
>
  <div cardContent class="flex flex-col">
    <h3 class="card__title">{{ element()?.name | infoDisplay }}</h3>
    <div class="card__description flex flex-row items-center gap-1.5">
      <span>{{ 'SITES.PRODUCTS.CARD.CONNECTOR' | translate }} : </span>
      <span> {{ element()?.type | infoDisplay }} </span>
    </div>
  </div>
</iot-platform-ui-simple-card>
